// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"fn","speechCardBox":"fn","speech-img-box":"fo","speechImgBox":"fo","card-content":"fp","cardContent":"fp","card-src":"fq","cardSrc":"fq"};